"use client";

import { useMediaQuery } from "@/hooks/use-media-query";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";
import AddAddressForm from "@/components/checkout/add-address-form";
import { trackAction } from "@/lib/track-action";

type AddAddressDialogProps = {
  open: boolean;
  onSuccess: (newAddressId: string | number) => void;
  onSkip: () => void;
};

export default function AddAddressDialog({ open, onSuccess, onSkip }: AddAddressDialogProps) {
  const handleSuccess = (newAddressId: string | number) => {
    trackAction("ADD-ADDRESS", String(newAddressId));
    onSuccess(newAddressId);
  };
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (isDesktop) {
    return (
      <Dialog open={open} onOpenChange={(o) => !o && onSkip()}>
        <DialogContent className="sm:max-w-lg max-h-[85vh] flex flex-col overflow-hidden pr-0">
          <DialogHeader className="pr-6">
            <DialogTitle>Agregar dirección de entrega</DialogTitle>
          </DialogHeader>
          <AddAddressForm
            onSuccess={handleSuccess}
            onCancel={onSkip}
            renderFooter={({ onBack, onSubmit, onCancel, isSubmitting, showBack }) => (
              <DialogFooter className="flex-shrink-0 pt-4 border-t bg-white pr-6">
                {showBack ? (
                  <>
                    <Button variant="outline" onClick={onBack} disabled={isSubmitting} className="cursor-pointer">
                      Atrás
                    </Button>
                    <Button onClick={onSubmit} disabled={isSubmitting} className="bg-teal-400 hover:bg-teal-500 cursor-pointer">
                      {isSubmitting ? "Guardando..." : "Guardar dirección"}
                    </Button>
                  </>
                ) : (
                  <>
                    <Button variant="ghost" onClick={onCancel} className="cursor-pointer text-muted-foreground">
                      Omitir
                    </Button>
                  </>
                )}
              </DialogFooter>
            )}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={open} onOpenChange={(o) => !o && onSkip()}>
      <DrawerContent className="min-h-[75vh] max-h-[90vh]">
        <DrawerHeader>
          <DrawerTitle>Agregar dirección de entrega</DrawerTitle>
        </DrawerHeader>
        <div className="px-4 flex-1 min-h-0 flex flex-col">
          <AddAddressForm
            onSuccess={handleSuccess}
            onCancel={onSkip}
            renderFooter={({ onBack, onSubmit, onCancel, isSubmitting, showBack }) =>
              showBack ? (
                <div className="flex-shrink-0 pt-4 pb-8 border-t bg-white">
                  <Button onClick={onSubmit} disabled={isSubmitting} className="w-full bg-teal-400 hover:bg-teal-500 cursor-pointer">
                    {isSubmitting ? "Guardando..." : "Guardar dirección"}
                  </Button>
                </div>
              ) : (
                <div className="flex-shrink-0 pt-4 pb-8">
                  <Button variant="ghost" onClick={onCancel} className="w-full cursor-pointer text-muted-foreground">
                    Omitir
                  </Button>
                </div>
              )
            }
          />
        </div>
      </DrawerContent>
    </Drawer>
  );
}
